import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import noop from 'lodash/noop';
import isNil from 'lodash/isNil';

import SlideshowBase_ViewerVersion1 from './slideshow_base.viewer_version1.jsx';
import SlideshowBase_ViewerVersion2 from './slideshow_base.viewer_version2.jsx';
import SlideshowBase_ViewerVersion3 from './slideshow_base.viewer_version3.jsx';

import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const SlideshowBase = (props) => {

  const shouldUseLegacySlideshow = !isNil(props.section.isUsingLegacySlideshow) ? props.section.isUsingLegacySlideshow : true;

  return (
    <Fragment>
      {shouldUseLegacySlideshow ? (
        <SiteViewerVersionComponentSelector>
          <SlideshowBase_ViewerVersion1 forSiteViewerVersion={1} {...props} />
          <SlideshowBase_ViewerVersion2 forSiteViewerVersion={2} {...props} />
        </SiteViewerVersionComponentSelector>
        ) : (
        <SlideshowBase_ViewerVersion3 {...props} />
      )}
    </Fragment>

  );
};

SlideshowBase.defaultProps = {
  onSlideDisplay: noop,
};

SlideshowBase.propTypes = {
  SlideshowItemComponent: PropTypes.oneOfType([
    PropTypes.instanceOf(Component),
    PropTypes.func,
  ]).isRequired,
  assetUrlsForPreload: PropTypes.array.isRequired,
  selectedContentItem: PropTypes.object,
  sectionId: PropTypes.string.isRequired,
  // Each element of contentItemAssetPairs contains a contentItem and
  // the asset associated with that contentItem
  contentItemAssetPairs: PropTypes.arrayOf(
    PropTypes.shape({
      contentItem: PropTypes.object,
      asset: PropTypes.object,
    })
  ).isRequired,
  videoishPlayerProps: PropTypes.object.isRequired,
  onSelectContentClick: PropTypes.func.isRequired,
  onSlideDisplay: PropTypes.func,
};

export default SlideshowBase;
